import script from "./Platform365JourneyDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./Platform365JourneyDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__